/**
 * Initial POI lists data.
 *
 * v1 seeds one mandatory default list so every POI can always be assigned.
 */
const initialPoiListsData = [
  {
    title: 'Default POIs',
    isDefault: true,
    createdAt: Date.now(),
    updatedAt: null
  }
];

export default initialPoiListsData;
